import { TutorialDefinition } from "../types";

const tour: TutorialDefinition = {
  id: "case-categories",
  version: "1.0.0",
  releasedAt: "2026-05-26T00:00:00.000Z",
  category: "new-feature",
  title: "Categories & Favorites",
  description:
    "Organize your cases into categories and star the ones you use most.",
  // Fire on an individual case page so the toolbar tag/star buttons (and the
  // sidebar categories) are all present.
  triggerRoute: /^\/cases\/[^/]+$/,
  autoStart: true,
  steps: [
    {
      target: '[data-tour="case-categories"]',
      title: "Categories",
      content:
        "Categories let you group related cases together. They're personal to you, and a single case can live in as many categories as you like. Selecting one filters the case list to just those cases.",
      disableBeacon: true,
      placement: "right",
    },
    {
      target: '[data-tour="new-category-button"]',
      title: "Create a category",
      content:
        "Click the + to make a new category. To file a case into one, just drag the case onto a category here.",
      placement: "right",
    },
    {
      target: '[data-tour="case-category-tag"]',
      title: "Add this case to a category",
      content:
        "You can also file the open case into categories from here. The tag turns blue once it's in one.",
      placement: "bottom",
    },
    {
      target: '[data-tour="favorite-star"]',
      title: "Favorite this case",
      content:
        "Favorite the open case from here. The star turns yellow once it's favorited.",
      placement: "bottom",
    },
    {
      target: '[data-tour="favorites-category"]',
      title: "Favorites",
      content:
        "Favorited cases gather here, so the ones you use most are always one click away. You can also drag a case onto Favorites to star it.",
      placement: "right",
    },
  ],
};

export default tour;
